import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="paraspace"><p>For example, if you are managing
                                                on a project team who are working to a tight deadline,
                                                working
                                                very long hours, all feeling pressurised and feel that
                                                deadlines cannot be met, you might conclude
                                                that you need to recruit an additional project member to
                                                spread the workload. However, taking
                                                this narrow approach may mean that you overlook the bigger
                                                picture. The project team:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Have unclear roles and responsibilities</p></li>
                                                <li><p>Are not working efficiently</p></li>
                                                <li><p>Are not sharing information</p></li>
                                                <li><p>Are not motivated to complete the project</p></li>
                                                <li className="list-bottom-pad"><p>Have a lack of
                                                    resources.</p></li>
                                            </ul>
                                            <p>Recruiting an additional project member will not help to
                                                solve the problem, as the other issues
                                                need to be addressed.</p>
                                            <p>So, how can we focus on the bigger picture, but in a
                                                one-step-at-a-time way? Read on to
                                                understand how you can do this.</p>

                                            <div className="border_subtitle">Biography</div>
                                            <p>Write your own mini biography as you would like it to be!
                                                What would people say about you? What
                                                defined you as a person? What were your biggest
                                                achievements? This is a very effective way to
                                                identify what it is that you really value and want to be
                                                remembered for!</p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
TOWS STRATEGIC ALTERNATIVES MATRIX
</span></div>
                                            <p>TOWS is an acronym for Threats, Opportunities, Weaknesses and
                                                Strengths. It is based on a
                                                SWOT analysis. SWOT traditionally focuses on the internal
                                                environment in isolation, whereas
                                                TOWS focuses on both internal and external factors.</p>
                                            <p>It is used to generate and classify a person’s strategic
                                                alternatives in a given situation – to help
                                                focus on the bigger picture. Using the TOWS model can help
                                                you to widen the number of options
                                                you consider rather than only focusing on the immediate
                                                options that spring to mind.</p>
                                            <p>The table below provides an outline of the TOWS model:</p>

                                            <div className="desktop ipad-portrait-show">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport1new tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="left" valign="top"
                                                            className="green_curve "></th>
                                                        <th width="20%" align="left" valign="top">External
                                                            Opportunities (O)
                                                        </th>
                                                        <th width="20%" align="left" valign="top"
                                                            className="green_curve1">External Threats (T)
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="greenbgtable"><p><span
                                                            className="subTableHEading">Internal Strengths (S)</span>
                                                        </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">SO</span></p>
                                                            </div>
                                                            <p>Strategies that <span
                                                                className="subtiltereg">use strengths
</span>to<span className="subtiltereg"> maximise opportunities</span>
                                                            </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">ST
</span></p></div>
                                                            <p>Strategies that <span
                                                                className="subtiltereg">use strengths</span>
                                                                to <span className="subtiltereg">minimise threats</span>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="greenbgtable"><p><span
                                                            className="subTableHEading">Internal Weaknesses (W)</span>
                                                        </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">WO

</span></p></div>
                                                            <p>Strategies that <span
                                                                className="subtiltereg">minimise
weaknesses</span> by <span className="subtiltereg">taking
advantage of opportunities</span>
                                                            </p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">WT

</span></p></div>
                                                            <p>Strategies that<span className="subtiltereg"> minimise
	   weaknesses</span> and <span className="subtiltereg">avoid threats</span>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%"></th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}}>
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Internal Strengths (S)</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable">External Opportunities
                                                            (O)
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">SO</span></p>
                                                            </div>
                                                            <p>Strategies that <span
                                                                className="subtiltereg">use strengths
</span>to<span className="subtiltereg"> maximise opportunities</span>
                                                            </p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable"
                                                            style={{borderBottomLeftRadius:'15px'}}>External
                                                            Threats (T)
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"
                                                            style={{borderBottomRightRadius:'15px'}}>
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">ST
</span></p></div>
                                                            <p>Strategies that <span
                                                                className="subtiltereg">use strengths</span>
                                                                to <span className="subtiltereg">minimise threats</span>
                                                            </p>

                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%"></th>
                                                        <td className="lightgreen"
                                                            style={{borderTopRightRadius: '15px'}}>
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Internal Weaknesses (W)</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable">External Opportunities
                                                            (O)
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">WO

</span></p></div>
                                                            <p>Strategies that <span
                                                                className="subtiltereg">minimise
weaknesses</span> by <span className="subtiltereg">taking
advantage of opportunities</span>
                                                            </p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="greenbgtable">External Threats (T)
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <div className="uiheading"><p><span
                                                                className="subTableHEading">WT

</span></p></div>
                                                            <p>Strategies that<span className="subtiltereg"> minimise
	   weaknesses</span> and <span className="subtiltereg">avoid threats</span>
                                                            </p>
                                                        </td>

                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <p>To use the TOWS model to your best advantage, follow the
                                                steps below:</p>
                                            <div className="border_subtitle">Step 1</div>
                                            <p>Think of a goal you want to achieve. Consider the information
                                                you have relating to your strategic
                                                alternatives and conduct a systematic review of this
                                                information. This will help you better
                                                understand your strengths and weaknesses, as well as
                                                identifying your opportunities and threats
                                                that you should focus on. Use the grid on the next page to
                                                identify and record your strengths,
                                                weaknesses, opportunities and threats.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}